import { Observable } from 'rxjs';
import { LoggerService } from '../logger/logger.service';
import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root',
})
export class CommonClientService {
  constructor(private readonly _logger: LoggerService) {}
  public openPopupToRetrieveAuthCode(provider: string, url: URL, state: string): Observable<string> {
    /*
     * The technique we use in order to open external integration login popup is inspired from msal: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/0cb022df51f2636710524a0f66ea2dafccd27b26/lib/msal-browser/src/interaction_handler/PopupHandler.ts#L55
     * We open a new window with url of external integration login page, after the user has a successful login the window automatically redirect to the uri that we provided
     * in the ui - so we constantly checking if the user finished the login
     */
    const popup = window.open(url);
    return new Observable((observer) => {
      const interval = setInterval(() => {
        if (popup?.closed) {
          // The popup window was closed before the user signed in
          clearInterval(interval);
          observer.error(`The user has closed ${provider} login page before he logged in`);
          return;
        }

        let href: string | undefined = '';
        try {
          /*
           * When popup window location is not the same as the portal origin, trying to access it will throw CORS exception
           * This exception is caught and ignored because it means the user is still on external integration login page
           */
          href = popup?.location.href;
        } catch {
          this._logger.warn(`The user is still on ${provider} login page`);
        }

        if (href === '' || href === 'about:blank') {
          // As long as we can't get the location we keep looping in this interval
          return;
        }

        const urlParams = new URLSearchParams(popup?.location.search);

        // Successful login should contain code and state in query params
        const ultParamCode = urlParams.get('code');
        const urlParamErrorDescription = urlParams.has('error_description');
        if (ultParamCode && urlParams.has('state') && urlParams.get('state') === state) {
          observer.next(ultParamCode);
        }
        // Failed login should contain error_description in query params
        else if (urlParamErrorDescription) {
          observer.error(urlParamErrorDescription);
        } else {
          observer.error("response query didn't include expected parameters");
        }

        clearInterval(interval);
        popup?.close();
      }, 50);
    });
  }
}
